tarteaucitron.user.multiplegtagUa = [];
tarteaucitron.user.multiplegoogletagmanagerId = [];

var gta = 'G-LHMJ89ZW4X';
var gtm = 'GTM-TWZ5Q3M';

//Google Analytics (gtag.js) a laisser par defaut
tarteaucitron.user.multiplegtagUa.push(gta);
//GTM
tarteaucitron.user.multiplegoogletagmanagerId.push(gtm);

(tarteaucitron.job = tarteaucitron.job || []).push('multiplegoogletagmanager');
(tarteaucitron.job = tarteaucitron.job || []).push('multiplegtag');
(tarteaucitron.job = tarteaucitron.job || []).push('iframe');

(tarteaucitron.job = tarteaucitron.job || []).push('googleadwordsconversion');



